import React from 'react';

import runLookupConfigModalForLabAutomation from 'lab-automation/settings/runLookupConfigModalForLabAutomation';
import EditableLookupConfigDisplay from 'lookup-config/EditableLookupConfigDisplay';
import {InferredLookupConfigType} from 'lookup-config/inferTypeFromLookupConfig';
import {
  BASE_FIRST_STEP_OPTIONS,
  DEFAULT_FINAL_LOOKUP_STEP_TYPES,
  DEFAULT_INTERMEDIATE_LOOKUP_STEP_TYPES,
  LookupConfigSpec,
} from 'lookup-config/LookupConfigModalConstants';
import {Schema} from 'schemas/SchemaConstants';

import {LabAutomationTransform} from '../../RunSchemaSpecConstants';

export default function LookupConfigInput(props: {
  baseSchema: Schema;
  transform: LabAutomationTransform & {lookupConfig?: LookupConfigSpec};
  onChange: (transform: LabAutomationTransform & {lookupConfig?: LookupConfigSpec}) => void;
  defaultIsMultiValue?: boolean;
  shouldShowIsMulti?: boolean;
  getLookupConfigValidationError?: (inferredType: InferredLookupConfigType) => string | null;
}): JSX.Element {
  function runLookupConfigModal(): void {
    runLookupConfigModalForLabAutomation({
      baseSchema: props.baseSchema,
      firstLookupStepTypes: BASE_FIRST_STEP_OPTIONS,
      intermediateLookupStepTypes: DEFAULT_INTERMEDIATE_LOOKUP_STEP_TYPES,
      finalLookupStepTypes: DEFAULT_FINAL_LOOKUP_STEP_TYPES,
      initialLookupConfig: props.transform.lookupConfig,
      defaultIsMultiValue: props.defaultIsMultiValue,
      shouldShowIsMulti: props.shouldShowIsMulti ?? true,
      getLookupConfigValidationError: props.getLookupConfigValidationError,
      onRequestSubmit: ([{lookupConfig}]) => {
        props.onChange({
          ...props.transform,
          lookupConfig,
        });
      },
    });
  }

  if (!props.transform.lookupConfig) {
    return (
      <div>
        <a onClick={runLookupConfigModal}>Set lookup</a>
      </div>
    );
  }
  return (
    <EditableLookupConfigDisplay
      baseSchema={props.baseSchema}
      lookupConfig={props.transform.lookupConfig}
      lookupType="column"
      onEdit={runLookupConfigModal}
      onRemove={() => {
        const newTransform = {...props.transform};
        delete newTransform.lookupConfig;
        props.onChange(newTransform);
      }}
    />
  );
}
